import "./App.css";
import AllRoutes from "./routes/AllRoutes";
import { AuthProvider } from "./context/AuthContext";
import Toaster from "./components/utils/Toaster";
import ScrollToTop from "./components/utils/ScrollToTop";
import { ToasterProvider } from "./components/utils/Toaster";
import DynamicHead from "./components/utils/DynamicHead";

function App() {
  return (
    <AuthProvider>
      <ToasterProvider>
        <div>
          <DynamicHead />
          <ScrollToTop />
          <AllRoutes />
          <Toaster />
        </div>
      </ToasterProvider>
    </AuthProvider>
  );
}

export default App;
